import React, { Component } from 'react';
import SaveButton from '../../../../commons/Buttons/SaveButton';

export default class Account extends Component {
    state = {
        isSaving: false
    };

    handleClick = () => {

    };

    render() {
        return (
            <div id="account_settings_container" ref="container">
                <div className="row">
                    <form action="">
                        <div className="form-group form-md-line-input col-md-12 col-lg-12 col-sm-12">
                            <label className="col-md-2 control-label" htmlFor="form_control_1">Subscription Type</label>
                            <div className="col-md-10">
                                <input type="text" className="form-control"
                                       id="form_control_1" placeholder="Enter your name" />
                                <div className="form-control-focus"> </div>
                            </div>
                        </div>

                        <hr/>

                        <div className="form-actions col-md-12 col-lg-12 col-sm-12"
                             style={{ borderTop: '1px #eef1f5 solid', paddingTop: '20px' }}>
                            <div className="btn-set pull-right" style={{ width: '150px' }}>
                                <SaveButton name="Save" loadingName="Saving"
                                            onClickEvent={this.handleClick}
                                            isLoading={this.state.isSaving}
                                            type="button" />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/management/settings/tabs/Account.js
 **/